import { render } from "./SystemResetForm.vue?vue&type=template&id=3575f5da&ts=true"
import script from "./SystemResetForm.vue?vue&type=script&lang=ts"
export * from "./SystemResetForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__